module.exports = __webpack_public_path__ + "static/media/manual_success.9ea04505.svg";